import {
  ADD_SOURCE_DATA,
  GET_SOURCE_DETAILS,
  GET_ALL_SOURCEDATA,
} from '../types'

const INITIAL_STATE = {
  addSourceData: [],
  sourceDataDetails: [],
  allSourceData: [],
}

const sourceDataReducer = (state = INITIAL_STATE, { type, payload }) => {
  switch (type) {
    case ADD_SOURCE_DATA:
      return {
        ...state,
        addSourceData: payload,
      }
    case GET_SOURCE_DETAILS:
      return {
        ...state,
        sourceDataDetails: payload.data,
      }
    case GET_ALL_SOURCEDATA:
      return {
        ...state,
        allSourceData: payload.data,
      }
    default:
      return state
  }
}

export default sourceDataReducer
